jQuery(function ($) {
  const t = theme.translate;

  const Multivariant = (function () {
    function Multivariant({el, data, manager, shouldShowViewCart = false}) {
      this.$el = $(el);
      this.data = data;
      this.manager = manager;
      this.isBusy = false;
      this.variantItemsInstances = [];
      this.shouldShowViewCart = shouldShowViewCart;
      this.isPreviewOnly = Boolean(theme.customer && theme.customer.isPreviewOnly);
      
      if (!el) {
        throw new Error('Product element cannot be null');
      }

      if (!data) {
        throw new Error('Product data cannot be null');
      }

      this.init();
    }

    Multivariant.prototype = Object.assign(Multivariant.prototype, {
      init() {
        this.initData();
        this.initTemplate();
        this.initElements();
        this.initEvents();
        this.initItems();
        this.sync();
        this.syncAddedToCartClass();
        this.$el.addClass('is-loaded');
      },

      initData() {
        let variants = this.data.variants.map(v => {
          return {
            ...v,
            quantityInCart: theme.CartV2.getItemQuantity(v.id),
            shouldShowOutOfStock: !v.availableForSale,
            shouldHideStockCount: v.availableForSale && v.quantityAvailable <= 0,
            stockStatus: v.quantityAvailable > 50 ? 'high-stock' : 'low-stock',
            isPreviewOnly: this.isPreviewOnly,
          };
        });
        
        variants = this.sortVariants(variants);

        const isComingSoon = this.checkIsComingSoon(),
          isIncompatibleWithCart = !this.checkCartCompatibility();

        this.data = {
          ...this.data,
          variants,
          totalsInFooter: this.data.variants.length > 3,
          hasError: isComingSoon || isIncompatibleWithCart,
          isComingSoon,
          isComingSoonError: t('cannotAddComingSoon'),
          isIncompatibleWithCart,
          addToCartLabel: t('addToCart'),
          cartUrl: theme.routes.cart,
          shouldShowViewCart: this.shouldShowViewCart,
          isPreviewOnly: this.isPreviewOnly,
        }
      },

      initTemplate() {
        let template = Handlebars.compile(getTemplate());

        this.$el.find('.wb-mv__sk').remove();
        this.$el.find('.wb-mv__main').html(template(this.data));
      },

      initElements() {
        this.$message = this.$el.find('.js-message');
        this.$amount = this.$el.find('.js-amount');
        this.$total = this.$el.find('.js-total');
        this.$addToCart = this.$el.find('.js-add-to-cart');
      },

      initEvents() {
        this.$addToCart.on('click', this.onAddToCartClick.bind(this));
      },

      initItems() {
        this.$el.find('[data-variant]').each((i, el) => {
          const data = this.getVariantDataById($(el).data('variant'));
          const variantItemInstance = new MultivariantItem({el, data});
          variantItemInstance.on('quantity_change', this.onVariantQuantityChange.bind(this));

          this.variantItemsInstances.push(variantItemInstance);
        })
      },

      onVariantQuantityChange(e, variant) {
        this.sync();
      },

      onAddToCartClick(e) {
        e.preventDefault();

        this.addItemsToCart();
      },

      addItemsToCart() {
        if (this.isBusy) {
          return;
        }

        this.busy(true).block(true).loading(true);

        let isUpdatingTheCart = this.shouldUpdateCart(),
          updates = theme.CartV2.prepareItemsForUpdate(this.getItemsWithQuantity());
        
        theme.CartV2.updateCart(updates)
          .then(data => {
            let message = isUpdatingTheCart
              ? t('updatedCart')
              : t('addedToCart');

            this.loading(false).showMessage(message);
            this.onCartUpdated();
          })
          .catch(err => {
            this.loading(false).showMessage(err, 'error');
          })
          .finally(() => {
            setTimeout(() => {
              this.showMessage('').block(false).busy(false);
            }, 2000);
          })
      },

      onCartUpdated() {
        this.syncAddToCart();
        this.syncGlobalMultivariants();
        this.syncAddedToCartClass();
      },

      busy(state) {
        this.isBusy = state;
        this.$el.toggleClass('is-busy', state);
        return this;
      },

      block(state) {
        this.$el.toggleClass('is-blocked', state);
        return this;
      },

      loading(state) {
        this.$el.toggleClass('is-loading', state);
        return this;
      },

      showMessage(message, state = 'success') {
        this.$message.attr('data-state', state).text(message)
        this.$el.toggleClass('is-showing-message', message);
        return this;
      },

      reset() {
        this.variantItemsInstances.forEach(instance => instance.reset());
        this.sync();
      },
      
      checkIsComingSoon() {
        return this.data.metafields?.find(m => m?.key === 'coming_soon')?.value === 'true';
      },

      checkCartCompatibility() {
        return theme.CartV2.isEmpty() || this.getStockType() === theme.CartV2.cartType;
      },

      checkCartContainsMultivariant() {
        return theme.CartV2.includes(this.getItemIDs());
      },

      shouldUpdateCart() {
        // if cart contains any variant from this instance then we should update
        return this.checkCartContainsMultivariant();
      },

      getAddToCartLabel() {
        return !this.shouldUpdateCart()
          ? t('addToCart')
          : t('updateCart');
      },

      getVariantDataById(variantId) {
        return this.data.variants.find(v => v.id == variantId);
      },

      getTotalQuantity() {
        return this.variantItemsInstances.reduce((a, v) => a + v.quantity, 0);
      },

      getTotalPrice() {
        return this.variantItemsInstances.reduce((a, v) => a + v.calcTotal(), 0);
      },

      getStockType() {
        return this.data.stockType;
      },

      getItemIDs() {
        return this.variantItemsInstances.map(i => i.getID());
      },

      getItemsWithQuantity() {
        return this.variantItemsInstances.map(i => {
          return {
            id: i.getID(),
            quantity: i.quantity,
          }
        });
      },

      canUpdateCart() {
        return theme.CartV2.isDifferentFrom(this.getItemsWithQuantity());
      },

      sync() {
        this.syncAmount();
        this.syncTotal();
        this.syncAddToCart();
      },

      syncAddedToCartClass() {
        this.$el.toggleClass('is-added-to-cart', this.checkCartContainsMultivariant());
      },

      syncAddToCart() {
        this.$addToCart.text(this.getAddToCartLabel())
          .attr('disabled', !this.canUpdateCart());
      },

      syncAmount() {
        this.$amount.text(this.getTotalQuantity());
      },

      syncTotal() {
        this.$total.html(theme.utils.formatMoney(this.getTotalPrice()));
      },

      syncGlobalMultivariants() {
        if(this.manager !== theme.ProductMultivariantsManager) {
          theme.ProductMultivariantsManager.setup();
        }
      },
      
      sortVariants(variants) {
        let variantsOrder = theme.settings.multivariantsOrder;
        variantsOrder = variantsOrder
          ? variantsOrder.split(",").map((a) => a.toUpperCase().trim())
          : [];

        // sort by id
        variants.sort((v1, v2) => v1.id - v2.id);

        // sort by custom order coming from theme settings (e.g. [XS, SM, M, L, XL])
        return variants.sort((v1, v2) => {
          index1 = variantsOrder.indexOf(v1.title.toUpperCase());
          index2 = variantsOrder.indexOf(v2.title.toUpperCase());

          if (index1 != -1 && index2 != -1) {
            return index1 - index2;
          }

          return index1 != -1 ? -1 : index2 != -1 ? 1 : 0;
        });
      }
    });

    function getTemplate() {
      return `<div class="wb-mv__inner">
    {{#unless hasError}}
        <div class="wb-mv__message js-message"></div>
        <div class="wb-mv__spinner"></div>

        <div class="wb-mv__options-wrapper">
            <div class="wb-mv__options">
                <div class="wb-mv__head">
                    <div class="wb-mv__head-items">
                        {{#each variants}}
                            <div class="wb-mv__head-item">
                                {{this.title}}
                            </div>
                        {{/each}}

                        {{#unless totalsInFooter }}
                            <div class="wb-mv__head-item wb-mv__head-item--amount">{{t 'cart.amount'}}</div>
                            <div class="wb-mv__head-item wb-mv__head-item--total">{{t 'cart.total'}}</div>
                        {{/unless}}
                    </div>
                </div>

                <div class="wb-mv__body">
                    <div class="wb-mv__body-items">
                        {{#each variants}}
                            <div class="wb-mv__body-item wb-mv__body-item--{{stockStatus}}" data-variant="{{id}}">
                                {{#unless shouldShowOutOfStock}}
                                    <div class="wb-mv__qty-box">
                                        {{#unless isPreviewOnly}}
                                          <div class="wb-mv__qty js-qty">
                                              <input type="number"
                                                     value="{{quantityInCart}}"
                                                     min="0"
                                                  {{#unless shouldHideStockCount}}max="{{quantityAvailable}}" {{/unless}}
                                                     class="wb-mv__qty-input js-qty-input">
                                              <button type="button" class="wb-mv__qty-btn wb-mv__qty-plus js-qty-plus">
                                                  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                                      <path d="M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm5 9h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                                                            fill="none"></path>
                                                      <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path>
                                                  </svg>
                                              </button>
                                              <button type="button" class="wb-mv__qty-btn wb-mv__qty-minus js-qty-minus">
                                                  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                                      <path d="M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm5 9H7v-2h10v2z"
                                                            fill="none"></path>
                                                      <path d="M7 11h10v2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path>
                                                  </svg>
                                              </button>
                                          </div>
                                            {{#unless isPreviewOnly}}
                                              {{#unless shouldHideStockCount}}
                                                  <div class="wb-mv__stock js-stock">{{quantityAvailable}} in stock</div>
                                              {{/unless}}
                                            {{/unless}}
                                        {{/unless}}

                                        <div class="wb-mv__price js-price">
                                            {{money price.amount}}
                                        </div>
                                    </div>
                                {{else}}
                                    <div class="wb-mv__out-of-stock">
                                        Out<br>of<br>Stock
                                        {{#if availability}}
                                            <div class="wb-mv__availability">back in {{availability}}</div>
                                        {{/if}}
                                    </div>
                                {{/unless}}
                            </div>
                        {{/each}}

                        {{#unless isPreviewOnly}}
                          {{#unless totalsInFooter }}
                              <div class="wb-mv__body-item wb-mv__body-item--amount js-amount">0</div>
                              <div class="wb-mv__body-item wb-mv__body-item--total js-total">{{money 0}}</div>
                          {{/unless}}
                        {{/unless}}
                    </div>
                </div>
            </div>
        </div>
        
        {{#unless isPreviewOnly }}
          <div class="wb-mv__foot">
              {{#if totalsInFooter}}
                  <div class="wb-mv__foot-totals">
                      <div class="wb-mv__foot-total wb-mv__foot-total--amount">
                          <div class="wb-mv__foot-total-label">{{t 'cart.amount'}}:</div>
                          <div class="wb-mv__foot-total-value js-amount">0</div>
                      </div>
  
                      <div class="wb-mv__foot-total wb-mv__foot-total--total">
                          <div class="wb-mv__foot-total-label">{{t 'cart.total'}}:</div>
                          <div class="wb-mv__foot-total-value js-total">{{money 0}}</div>
                      </div>
                  </div>
              {{/if}}
  
              <div class="wb-mv__btn-wrapper">
                  <button type="button" class="wb-btn wb-btn--v2 wb-btn--primary wb-btn--full wb-btn--upper js-add-to-cart">
                      {{addToCartLabel}}
                  </button>
              </div>
  
              <div class="wb-mv__foot-bottom">
                  {{#if shouldShowViewCart}}
                      <div class="wb-mv__foot-view-cart js-view-cart">
                          <a href="{{cartUrl}}" class="underlined-link">{{t 'cart.viewCart'}}</a>
                      </div>
                  {{/if}}
              </div>
          </div>
        {{/unless}}
    {{else}}
        <div class="wb-mv__cart-error">
            <div class="notice-message notice-message--error">
                {{#if isComingSoon}}
                    {{{isComingSoonError}}}
                {{else}}
                    {{{stockTypeCartError}}}
                {{/if}}
            </div>
        </div>
    {{/unless}}
</div>`;
    }

    return Multivariant;
  })();

  const MultivariantItem = (function () {
    function MultivariantItem({el, data}) {
      this.$el = $(el);
      this.data = data;
      this.quantity = data.quantityInCart;
      this.init();
    }

    MultivariantItem.prototype = Object.assign(MultivariantItem.prototype, {
      init() {
        this.initElements();
        this.initQtyInput();
        this.syncPrice();
      },

      initElements() {
        this.$stock = this.$el.find('.js-stock');
        this.$price = this.$el.find('.js-price')
      },

      initQtyInput() {
        this.qtyInput = new QtyInput(this.$el.find('.js-qty').get(0));
        this.qtyInput.on('quantity_change', this.onQuantityChange.bind(this));
      },

      onQuantityChange(e, quantity) {
        e.stopPropagation();
        this.quantity = quantity;
        this.syncPrice();
        this.$el.trigger('quantity_change', this);
      },

      calcTotal() {
        return parseFloat(this.data.price.amount) * this.quantity;
      },

      calcTotalForBelowInput() {
        qty = this.quantity > 0 ? this.quantity : 1;
        return parseFloat(this.data.price.amount) * qty;
      },

      reset() {
        this.quantity = 0;
        this.syncQuantityInput();
      },

      on(event, cb) {
        this.$el.on(event, cb);
      },

      syncQuantityInput() {
        this.qtyInput.set(this.quantity);
      },

      syncPrice() {
        this.$price.html(theme.utils.formatMoney(this.calcTotalForBelowInput()));
      },

      getID() {
        return this.data.id;
      }
    });

    return MultivariantItem;
  })();

  const QtyInput = (function () {
    function QtyInput(el) {
      this.$el = $(el);
      this.$input = this.$el.find('.js-qty-input');
      this.$plus = this.$el.find('.js-qty-plus');
      this.$minus = this.$el.find('.js-qty-minus');
      this.min = parseInt(this.$input.attr('min'));
      this.max = parseInt(this.$input.attr('max'));
      this.step = parseInt(this.$input.attr('step')) || 1;
      this.val = 0;

      this.init();
    }

    QtyInput.prototype = Object.assign(QtyInput.prototype, {
      init() {
        this.initEvents();
        this.initVal();
      },

      initVal() {
        this.set(this.$input.val());
      },

      initEvents() {
        this.$input.on('input', this.onInput.bind(this));
        this.$plus.on('click', this.increment.bind(this));
        this.$minus.on('click', this.decrement.bind(this));
      },

      validate(val) {
        val = parseInt(val);

        if (isNaN(val)) {
          return isNaN(this.min) ? 0 : this.min;
        }

        if (!isNaN(this.min) && val < this.min) {
          return this.min;
        }

        if (!isNaN(this.max) && val > this.max) {
          return this.max;
        }

        return val;
      },

      set(val) {
        val = this.validate(val);
        this.$input.val(val);

        if (this.val != val) {
          this.$input.trigger('quantity_change', val);
        }

        this.val = val;
      },

      increment() {
        this.set(this.val + this.step)
      },

      decrement() {
        this.set(this.val - this.step)
      },

      onInput() {
        let val = parseInt(this.$input.val());
        this.set(val);
      },

      on(event, cb) {
        this.$input.on(event, cb);
      }
    })

    return QtyInput;
  })();

  const MultivariantsManager = (function () {
    function MultivariantsManager($wrapper) {
      this.$wrapper = $wrapper;

      if (!($wrapper instanceof jQuery)) {
        this.$wrapper = $($wrapper);
      }
    }

    MultivariantsManager.prototype = Object.assign(MultivariantsManager.prototype, {
      setup() {
        const $elements = this.$wrapper.find('.wb-mv');

        if ($elements.length) {
          this.setupElements($elements);
        }
      },

      setupElements($elements) {
        let self = this;
        let productIds = $elements.toArray().map(item => $(item).data('product-id'));

        theme.CartV2.loadIfNull()
          .then(onCartLoaded);

        function onCartLoaded() {
          theme.StorefrontApi.getProducts(productIds, {featuredImageArgs: {maxWidth: 150}})
            .then(data => onProductsLoaded(data));
        }

        function onProductsLoaded(productsData) {
          $elements.each((i, el) => {
            let data = productsData.find(d => d.id == theme.utils.toGid($(el).data('product-id'))),
            shouldShowViewCart = 'showViewCart' in el.dataset;

            new Multivariant({el, data, manager: self, shouldShowViewCart})
          });
        }
      }
    });

    return MultivariantsManager;
  })();

  theme.MultivariantsManager = MultivariantsManager;

  theme.ProductMultivariantsManager = new MultivariantsManager('.wb-product-cart');
  theme.ProductMultivariantsManager.setup();
});